import { render, staticRenderFns } from "./subjectRender.vue?vue&type=template&id=52b40a9e&scoped=true"
import script from "./subjectRender.vue?vue&type=script&lang=js"
export * from "./subjectRender.vue?vue&type=script&lang=js"
import style0 from "./subjectRender.vue?vue&type=style&index=0&id=52b40a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b40a9e",
  null
  
)

export default component.exports